<template>
  <div>
    <Markdown :text="checkpoint.task"></Markdown>
    <h1><a :href="checkpoint.resourceUrl">{{ checkpoint.resourceUrl }}</a></h1>
  </div>
</div>
</template>

<script>
import Markdown from './Markdown.vue';
import { checkpointsRef  } from '../db';
export default {
  name: 'checkpoint-view',
  components: { Markdown },
  props: ["checkpoint"],
}
</script>

<style scoped>
div a h1 {
  text-color: "red"
}
</style>



// WEBPACK FOOTER //
// src/components/CheckpointView.vue